import React, { useRef } from 'react';
import {
  DateField,
  Datagrid,
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Title,
} from 'react-admin';

import { Card, makeStyles } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import TextoField from '../../Components/ReactAdmin/Fields/TextoField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { PERMISSAO_TELA_TRANSACOES_SIMULADAS_LISTAR } from '../../utils/dadosTelas';
import DialogoCreateEdit from './DialogoCreateEdit';
import DialogoDelete from './DialogoDelete';
//import ActionsField from './Fields/ActionsField';
import ValorField from './Fields/ValorField';
import Filter from './Filter';

const useStylesDatagrid = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: '#f8f8f8',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));
//
const MyList = ({ ...props }) => {
  const refresh = useRefresh();
  const refDialogoCreateEdit = useRef(null);
  const refDialogoDelete = useRef(null);

  const classes = useStylesDatagrid();

  const create = (data) => {
    if (refDialogoCreateEdit.current) {
      refDialogoCreateEdit.current.handleCreate();
    }
  };

  const edit = (data) => {
    if (refDialogoCreateEdit.current) {
      refDialogoCreateEdit.current.handleEdit(data.id);
    }
  };

  const deletar = (data) => {
    if (refDialogoDelete.current) {
      refDialogoDelete.current.handleOpen(data.id);
    }
  };

  const handleClose = () => {
    refresh();
  };

  return (
    <>
      <Title title="Transações Simuladas" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList {...props} handleCriar={create} />}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props} bulkActionButtons={false}>
          <DateField
            source="data_pagamento"
            label="Data"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <TextoField
            source="nome"
            label="nome"
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <ValorField
            source="valor"
            textAlign="right"
            label="Valor"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <ActionsField
            source="lalala"
            /* handleEdit={edit}
            handleDelete={deletar} */
            textAlign="right"
            label="Ações"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            sortable={false}
            actions={[
              {
                title: 'Editar',
                icon: <EditOutlinedIcon />,
                onClick: (record) => edit(record),
                show: () => true,
                disabled: () => false,
              },
              {
                title: 'Deletar',
                icon: <DeleteOutlineIcon />,
                onClick: (record) => deletar(record),
                show: () => true,
                disabled: () => false,
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <DialogoCreateEdit ref={refDialogoCreateEdit} handleClose={handleClose} />
      <DialogoDelete ref={refDialogoDelete} handleClose={handleClose} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_TRANSACOES_SIMULADAS_LISTAR}>
    <ContainerMyList
      {...props}
      filters={<Filter />}
      title="Transações Simuladas"
      component="div"
      bulkActionButtons={false}
      sort={{ field: 'data_pagamento', order: 'DESC' }}
      pagination={<TransacoesPagination />}
      perPage={50}
      filterDefaultValues={{
        periodo: {
          start: new Date(),
          end: new Date(),
        },
      }}
    />
  </ProtegerPagina>
);

export default List2;
